// eslint-disable-next-line local-rules/disallow-import-special-lib
import axios, { AxiosError, AxiosInstance, AxiosResponse } from "axios";
import React from "react";
import { getConfig, isBrowser } from "../../utils";
import { getGatewayHeaders } from "../header";
import { gatewayResponseErrorHandler, gatewayResponseHandler, paramsSerializer, responseFromGateway, urlResolve } from "./utils";
import * as R from 'ramda'

/**
 * pos api 请求对象
 */
const axiosGateway = axios.create({
  paramsSerializer,
  headers:{
    'Cache-Control':'no-cache'
  },
  timeout: 30 * 1000,
});

axiosGateway.interceptors.request.use(async config => {
  // 原 api2*.fantuan.ca 的所有 api 均通过 gateway 来代理调用
  // 代理规则：*-gateway*.fantuan.ca/api/pos/**/* => api2*.fantuan.ca/**/*
  const baseURL = `${getConfig('gateway')}/api/`;
  config.url = urlResolve(baseURL,config.url);
  if(config.url?.startsWith('/')){
    config.url = `/api/pos${config.url}`
  }
  config.url = urlResolve(baseURL,config.url);
  config.headers = {
    ...(await getGatewayHeaders()),
    ...config.headers,
  };

  return config;
});

const guessErrorMsg=(data:any):string=>{
  let msg = "";
  const type = R.type(data);
  if(type === 'Object' && data.msg!==undefined && data.code!==undefined ){
    const msgType=R.type(data.msg)
    if(msgType==='Object'||msgType==="Array"){
      return guessErrorMsg(data.msg);
    }
    return msg
  }
  if (type === 'Array' || type === 'Object') {
    let _temp = R.mergeAll<any>(data)
    _temp = R.values(_temp);
    _temp = R.flatten(_temp);
    _temp =(_temp as []).filter((x)=>typeof x==='string'&& x).join(',')
    msg =`${_temp||''}`.trim()
  }
  return msg;
}

/**
 * 规范化响应数据(将 api 错误时的数据结构标准化)
 * @param data
 * @returns
 */
 const responseDataNormal = (response:AxiosResponse<any>,maybeError:boolean=true): AxiosResponse<KeyValue> => {
  let intl = ({formatMessage: () => {}}) as any
  if (isBrowser()) {
    intl = window.__intl;
  }
  let data = response.data;
  if (typeof data === "string" && data!=='') {
    const code = response.status===200 ? -1 : response.status
    if (/^<!DOCTYPE HTML/i.test(data)) {
      data = { code, msg:'', __response_data: data }
    }else{
      data = { code, msg: data }
    }
  }else if(typeof data === "number" || typeof data === "boolean" || data === ""){
    data = { data: data }
  }
  data = data || {}
  if(maybeError){
    const code = data.code ?? response.status ?? -1;
    const msg = guessErrorMsg(data) || data.msg  || intl.formatMessage({id:'服务端异常'});
    // 这里不直接修改原对象而使用 Object.defineProperties 是为了不改变原属性的可枚举型
    Object.defineProperties(data,{
      code:{ value:code, configurable:true },
      msg:{ value:msg, configurable:true },
    });
  }else{
    const code:number = data.code ?? 0;
    const msg:string = data.msg || (code===0 ? "" : intl.formatMessage({id:'服务端业务异常'}));
    Object.defineProperties(data,{
      code:{ value:code, configurable:true },
      msg:{ value:msg, configurable:true },
    });
  }
  response.data = data;
  return response;
};
/**
 * 请求成功处理（http 200）
 * @param response
 * @returns
 */
function responseHandler(response: AxiosResponse<KeyValue>) {
  if(responseFromGateway(response)){
    return gatewayResponseHandler(response)
  }
  responseDataNormal(response,false);
  const { code,msg } = response.data;
  if(code !== 0){ // 服务端业务异常，返回 Promise.reject 将错误抛出，统一在 responseErrorHandler 中处理
    const error: AxiosError = Object.assign(new Error(msg),{
      config:response.config,
      request:response.request,
      response,
    })
    return Promise.reject(error)
  }
  return response;
}
/**
 * 请求错误处理（http 非 200）
 * @param error
 * @returns
 */
async function responseErrorHandler(error: AxiosError, axiosInstance: AxiosInstance) {
  if(!error.request){
    return Promise.reject(error);
  }
  if(!error.response){
    return Promise.reject(error);
  }
  let response = error.response;
  if(responseFromGateway(response)){
    return gatewayResponseErrorHandler(error,axiosInstance)
  }
  responseDataNormal(response,true);
  
  return Promise.reject(error);
}

axiosGateway.interceptors.response.use(
  response => responseHandler(response),
  error => Promise.reject(error)
);
axiosGateway.interceptors.response.use(
  response => response,
  error => responseErrorHandler(error,axiosGateway)
);

export default axiosGateway;


